<div class="nowrap button-content" [class.is-active]="isActive()" [class.high-contrast]="highContrast()">
    @if (displayedIconName(); as iconName) {
        <ui-icon size="small" iconStyle="bold" [rawColor]="iconColor()" [name]="iconName" />
    }
    <span class="button-text">
        <ng-content />
    </span>
</div>
